import { Button } from '@components/button';
import { FiltersConjunctionType } from '@components/filters';
import { IconDownload } from '@components/icons/download';

import { FilterHeader } from 'components/headers';
import { useModal } from 'features/modals';
import { useStore } from 'models/Provider';

import { useApplicantsFilterState } from './applicants-config';

export const ApplicantsHeader = ({
  count,
  totalCount,
  conjunction,
  query,
}: {
  totalCount: number;
  count: number;
  conjunction?: FiltersConjunctionType;
  query: string;
}) => {
  const { t } = useStore();
  const filterState = useApplicantsFilterState();
  const { showModal } = useModal();

  return (
    <FilterHeader
      title={t('navigation.applicants')}
      filterState={filterState}
      searchPlaceholder={t('applicants.header.search.placeholder')}
    >
      <Button
        variant="secondary"
        text={t('job.options.export')}
        iconRight={<IconDownload />}
        onClick={() => {
          showModal('EXPORT_APPLICANTS', {
            _container: {
              autoWidth: false,
            },
            query,
            conjunction: conjunction || 'and',
            count,
            totalCount,
          });
        }}
      />
    </FilterHeader>
  );
};
